const ExperienceData = [
  {
    title: "Software Engineer 3",
    company: "Public Consulting Group",
    description: `This is where I currently am. I primarily work with Spring Boot and 
                  Java to create REST services. I also configure and deploy AWS resources 
                  that are required by these backend services. For more information on what I
                  do/have done, please check my resume.`,
    dateStart: "September 2022",
    dateEnd: "Current",
    img: require("../img/pcg.svg"),
  },
  {
    title: "Student Assistant",
    company: "Franchise Tax Board",
    description: `In this role, I assisted the Paper Data Capture Operations 
                  team by providing technological support to their 
                  business customers. This either meant resolving 
                  hardware/software issues on ibml FUSiON scanners 
                  or implementing data fixes in Microsoft SQL 
                  Server/Oracle SQL Server. I also developed 
                  a command-line based PowerShell script to 
                  automate reoccuring Microsoft SQL Server data fixes.`,
    dateStart: "September 2021",
    dateEnd: "September 2022",
    img: require("../img/ftb.svg"),
  }
];

export default ExperienceData;
